import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	HostBinding,
	Output,
	EventEmitter,
	ChangeDetectionStrategy
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";
import { Locale } from "../datatable.models";
import { Column } from "../Column";
import { guid } from "../../shared/utils/generic";
import { IGenericSelectOption } from "../../shared/types/forms";

interface IFilteredColumn extends IGenericSelectOption, Column { }

@Component({
	selector: "rbc-datatable-column-filter",
	templateUrl: "./datatable-column-filter.component.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatableColumnFilterComponent {
	@Input() id: string;
	@Input() locale = Locale;
	@Input() set columns(val){
		this.filteredColumns = val;
	};


	@HostBinding("class.rbc-datatable-columnfilter") host = true

	@Output() onColumnFilterCheckBoxUpdated = new EventEmitter<Column[]>();

	_columns;
	get filteredColumns() {
		return this.selectedColumns;
	}
	set filteredColumns(val){
		this.selectedColumns = this.extendColumns(val);
	}
	selectedColumns = [];

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}


	onMultiselectUpdate(multiselectEvent: IFilteredColumn[]) {
		this.onColumnFilterCheckBoxUpdated.emit(this.selectedColumns);
	}
	// prepare columns for use in multi-select
	extendColumns(cols: Column[]): IFilteredColumn[] {
		if(cols){
			return cols.map(col => {
				return {
					label: col.header,
					value: col.header,
					disabled: col.isMandatory,
					selected: col.show,
					...col
				};
			});
		}
	}
}
